import ClubFile from '../../dto/club/ClubFile.js';
import Error from '../../model/Error';
import axios from 'axios';

export default class ClubFileRepository {
    static findByClubId(clubId, params = null) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/files`, { params })
                .then((response) => resolve(response.data.data.map((data) => ClubFile.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
